module.exports = __webpack_public_path__ + "static/media/zoom-in-icon.97b5d240.svg";